import { ApiUrl } from "../config/apiConfig";
import { postData } from "../services/Axios/Axios";

const sendAccountStatusChangeMail = (
    email: string,
    username: string,
    status: string,
    password: string = "qwerty"
) => {
    let mailTemplate;

    if (status === "CONFIRMED") {
        mailTemplate = {
            subject: "🎉 Your Admin Account Has Been Created!",
            html: `<div style="font-family: Arial, sans-serif; padding: 20px; max-width: 600px; margin: auto; border: 1px solid #e0e0e0; border-radius: 10px; background-color: #f9fdf9;">
  <h2 style="color: #007070;">✅ Hi ${username}, your admin account has been created!</h2>
  
  <p style="font-size: 16px; color: #333;">We’re excited to welcome you! Your account has been successfully created.</p>
  <p style="font-size: 16px; color: #333;">You can now log in and start exploring all the features of our platform.</p>

  <div style="margin: 30px 0; padding: 15px; background-color: #e6f7f7; border-left: 5px solid #007070; border-radius: 5px;">
    <p style="margin: 0 0 10px 0; font-size: 16px; color: #007070;"><strong>Your login credentials:</strong></p>
    <p style="margin: 0; font-size: 15px; color: #333;"><strong>Email:</strong> ${email}</p>
    <p style="margin: 0; font-size: 15px; color: #333;"><strong>Password:</strong> ${password}</p>
  </div>



  <p style="font-size: 14px; color: #888;">Need help? Reach out to our support team anytime.</p>
</div>`,
        };
    } else if (status === "DENIED") {
        mailTemplate = {
            subject: "⚠️ Your Account Request Has Been Rejected",
            html: `<div style='font-family: Arial, sans-serif; padding: 20px; max-width: 600px; margin: auto; border: 1px solid #ffe0e0; border-radius: 10px; background-color: #fff8f8;'>\n  <h2 style='color: #f44336;'>⛔ Hello ${username}, we’re sorry to inform you</h2>\n  <p style='font-size: 16px; color: #444;'>Your account registration request has been <strong>rejected</strong> after review by our admin team.</p>\n  <p style='font-size: 16px; color: #444;'>This may be due to missing information or not meeting our eligibility criteria.</p>\n  <p style='font-size: 16px; color: #444;'>You are welcome to re-apply or contact support for clarification.</p>\n  <div style='margin-top: 30px;'>\n    <a href='mailto:info@awahe.com' style='display: inline-block; padding: 10px 20px; background-color: #f44336; color: white; text-decoration: none; border-radius: 5px;'>Contact Support</a>\n  </div>\n</div>`,
        };
    } else {
        mailTemplate = {
            subject: "⏳ Your Account is Under Review",
            html: `<div style='font-family: Arial, sans-serif; padding: 20px; max-width: 600px; margin: auto; border: 1px solid #ddd; border-radius: 10px; background-color: #fcfcfc;'>\n  <h2 style='color: #2196F3;'>🔎 Hello ${username}, your account is currently pending review</h2>\n  <p style='font-size: 16px; color: #333;'>Thank you for submitting your registration request.</p>\n  <p style='font-size: 16px; color: #333;'>Our admin team is currently reviewing your details. We will notify you as soon as your account is either <strong>approved</strong> or <strong>rejected</strong>.</p>\n  <p style='font-size: 16px; color: #333;'>We appreciate your patience and will get back to you shortly.</p>\n  <div style='margin-top: 30px;'>\n    <p style='font-size: 14px; color: #888;'>For urgent queries, feel free to contact our support team.</p>\n  </div>\n</div>`,
        };
    }

    const payload = {
        emailType: "custom",
        recipient: email,
        data: mailTemplate,
    };

    return postData(ApiUrl.sendMail, payload);
};

export { sendAccountStatusChangeMail };
